module.exports = __webpack_public_path__ + "static/media/S4N3-1.c37edc95.svg";